import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ArrowRight } from 'lucide-react';

const LINKS = [
  { to: '/ppf', label: 'PPF' },
  { to: '/services/ceramic', label: 'Ceramic' },
  { to: '/services/tint', label: 'Tint' },
  { to: '/services/wrap', label: 'Wrap' },
  { to: '/ev', label: 'EV' },
  { to: '/build', label: 'Build' },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 12);
    on();
    window.addEventListener('scroll', on, { passive: true });
    return () => window.removeEventListener('scroll', on);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <header data-testid="site-nav" className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled || open ? 'bg-white/90 backdrop-blur-md hair-b' : 'bg-transparent'}`}>
      <div className="px-6 md:px-10 h-[76px] flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <img src="/brand/logo-dark.png" alt="SupremeX Detailing" className="h-6 md:h-7 w-auto" />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`linkline meta ${pathname === l.to ? 'text-red active' : ''}`}
            >
              {l.label}
            </Link>
          ))}
          <Link to="/#book" data-testid="nav-book" className="btn btn-red">Book <ArrowRight size={13} /></Link>
        </nav>

        <button data-testid="nav-menu-toggle" onClick={() => setOpen(!open)} className="md:hidden text-[#141414]" aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white hair-t" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            {LINKS.map((l) => (
              <Link key={l.to} to={l.to} data-testid={`mobile-nav-${l.label.toLowerCase()}`} className="meta text-[#141414]">{l.label}</Link>
            ))}
            <Link to="/#book" className="btn btn-red w-fit">Book a consultation <ArrowRight size={13} /></Link>
          </div>
        </div>
      )}
    </header>
  );
}
